import {rootAction} from "../apiAction";

export const REQUEST_START_REGISTRATION = 'REQUEST_START_REGISTRATION';
export const SUCCESS_START_REGISTRATION ='SUCCESS_START_REGISTRATION';
export const FAILURE_START_REGISTRATION = 'FAILURE_START_REGISTRATION';

export const REQUEST_CLEAR_REGISTRATION_INFO = 'REQUEST_CLEAR_REGISTRATION_INFO';

export const REQUEST_FINISH_REGISTRATION = 'REQUEST_FINISH_REGISTRATION';
export const SUCCESS_FINISH_REGISTRATION ='SUCCESS_FINISH_REGISTRATION';
export const FAILURE_FINISH_REGISTRATION = 'FAILURE_FINISH_REGISTRATION';


export const startRegistrationProcess = (userId) => dispatch => {
  return dispatch(rootAction(
    'POST',
    `notary/identification`,
    {"userId": userId},
    {
      request: REQUEST_START_REGISTRATION,
      success: SUCCESS_START_REGISTRATION,
      failure: FAILURE_START_REGISTRATION
    }
  ));
};

export const clearStartRegistrationProcessInfo = () => dispatch => {
  return dispatch({
      type: REQUEST_CLEAR_REGISTRATION_INFO,
    }
  )
};


export const finishRegistrationProcess = (data) => dispatch => {
  return dispatch(rootAction(
    'POST',
    `notary/registration`,
    data,
    {
      request: REQUEST_FINISH_REGISTRATION,
      success: SUCCESS_FINISH_REGISTRATION,
      failure: FAILURE_FINISH_REGISTRATION
    }
  ));
};

